/**
 * Module 02 · Connect: an agent's configured risk level (routing v2, PRD R2).
 *
 * Stored on the agent as `llm.risk_level`: "Low" | "Medium" | "High", or null
 * when not set. Org routing rules with a riskLevel condition match on it, and
 * Auto model selection sizes the model by it. Steps that change data in
 * connected systems are raised to High at run time regardless.
 *
 * React-free so the editor, the create wizard and the flow builder share it.
 */

import type { AgentRiskLevel } from '@/lib/api/types/process-flows';

export const AGENT_RISK_LEVELS: readonly AgentRiskLevel[] = ['Low', 'Medium', 'High'];

/** Picker options; '' is "Not set" (saved as null). */
export const RISK_LEVEL_OPTIONS: readonly { value: AgentRiskLevel | ''; label: string }[] = [
  { value: '', label: 'Not set' },
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
];

export const RISK_LEVEL_HELP =
  'Used by routing rules and Auto model selection. Steps that change data in connected systems are treated as High automatically.';

/** A stored value as the picker's value: a known level, else '' (Not set). */
export function riskLevelFromStored(v: unknown): AgentRiskLevel | '' {
  return AGENT_RISK_LEVELS.includes(v as AgentRiskLevel) ? (v as AgentRiskLevel) : '';
}

/** The picker's value as stored on `llm.risk_level`: '' becomes null. */
export function riskLevelToStored(v: AgentRiskLevel | '' | null | undefined): AgentRiskLevel | null {
  return v && AGENT_RISK_LEVELS.includes(v) ? v : null;
}
